module.exports = __webpack_public_path__ + "static/media/product_list_4.2e53c4c7.png";